/**
 * Maritime Connectivity Platform Service Registry API
 * Maritime Connectivity Platform Service Registry, developed by the MCC MSR WG
 *
 * OpenAPI spec version: 0.0.8
 * Contact: info@maritimeconnectivity.net
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Envelope { 
    diameter?: number;
    height?: number;
    area?: number;
    minX?: number;
    maxX?: number;
    minY?: number;
    maxY?: number;
    width?: number;
    _null?: boolean;
}